import React from 'react';
import './about-page.css'

export default class AboutPage extends React.Component {
    render() {
        return (
            <div className="description">
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/about-page.js